import PropTypes from 'prop-types'

/**
 * @typedef {Object} ExternalDataSharingOptions
 * @property {string} [optionId]          - The identifier of the option (WfExtDataSharingOption)
 * @property {string} [optionName]        - The name of the option
 * @property {string} [optionStringCode]  - The string code of the option
 */
export const externalDataSharingOptionsPropType = PropTypes.shape({
    optionId: PropTypes.string,
    optionName: PropTypes.string,
    optionStringCode: PropTypes.string
})
